export const PricingCard = {
  flow: 'y',
  gap: 'A',
  padding: 'B',
  background: 'surfaceBorder',
  border: '1px solid surfaceBorderStrong',
  borderRadius: 'Z',
  flex: '1',
  minWidth: 'F',

  BadgeText: {
    if: false,
    color: 'green',
    fontSize: 'Z',
    fontWeight: '700',
  },
  TierName: {
    fontSize: 'B',
    fontWeight: '600',
    color: 'text',
  },
  TierTarget: {
    fontSize: 'A',
    color: 'textMuted',
  },
  TierPrice: {
    tag: 'span',
    fontSize: 'C',
    fontWeight: '800',
    color: 'text',
  },
  TierPeriod: {
    text: 'თვეში',
    fontSize: 'A',
    color: 'textMuted',
  },
  FeaturesList: {
    flow: 'y',
    gap: 'Z',
    padding: 'A 0 0 0',
    borderTop: '1px solid surfaceBorderStrong',
    childExtends: {
      fontSize: 'A',
      color: 'textSoft',
      lineHeight: '1.5',
    },
  },
  TierCta: {
    extends: 'Link',
    href: '/dashboard',
    text: 'აირჩიეთ →',
    background: 'transparent',
    color: 'text',
    border: '1px solid surfaceBorderStrong',
    padding: 'Z A',
    fontSize: 'A',
    borderRadius: 'Z',
    width: '100%',
    textAlign: 'center',
    textDecoration: 'none',
    cursor: 'pointer',
    transition: 'transform 200ms',
    ':hover': { transform: 'scale(0.98)' },
    onClick: (e, el, s) => s.root.update({ loggedIn: true }),
  },
}

export const PricingCardHighlighted = {
  extends: 'PricingCard',
  background: 'greenBg',
  border: '2px solid green',
  TierPrice: { color: 'green' },
  TierCta: { background: 'green', color: 'neutral950', border: '1px solid green' },
}
